import { types } from 'mobx-state-tree';

export const TopCompetitor = types.model('TopCompetitor', {
    companyName: types.maybe(types.string),
    revenue: types.maybe(types.number),
    website: types.maybe(types.string),
    strengths: types.maybe(types.string),
    weaknesses: types.maybe(types.string),
    location: types.maybe(types.string)
});